import { loginWithEmailAndPassword } from "../../api/signin/index";

export const loginUserWithEmailAndPasswordCredentials = async (payload: any) => {
  const response = await loginWithEmailAndPassword(payload);
  return response;
};